export enum NotificationTypeEnum {
  COMPANY = "COMPANY",
  ATTENDANCE = "ATTENDANCE",
  USER = "USER",
  MESSAGE = "MESSAGE",
  WARNING_WORD = "WARNING_WORD",
  IMPORTATION = "IMPORTATION",
  CSAT = "CSAT",
  USER_ADDED = "USER_ADDED",
  CREDIT = "CREDIT",
  INTEGRATION = "INTEGRATION",
}